// extracted by mini-css-extract-plugin
export default {"dayOfWeek":"ServiceWorkScheduleBlock_dayOfWeek__lc48Z","weekend":"ServiceWorkScheduleBlock_weekend__KcC41","scheduleList":"ServiceWorkScheduleBlock_scheduleList__cViUP"};